let sequence = 0;

export function nextFieldId(prefix = 'cp-field') {
  sequence += 1;
  return `${prefix}-${sequence}`;
}
